/* eslint-disable */
import { useEffect } from 'react';
var usePageLeave = function (onPageLeave, args) {
    if (args === void 0) { args = []; }
    useEffect(function () {
        if (!onPageLeave) {
            return;
        }
        var handler = function (event) {
            event = event ? event : window.event;
            var from = event.relatedTarget || event.toElement;
            if (!from || from.nodeName === 'HTML') {
                onPageLeave();
            }
        };
        document.addEventListener('mouseout', handler);
        return function () {
            document.removeEventListener('mouseout', handler);
        };
    }, args);
};
export default usePageLeave;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/usePageLeave.js
// module id = N7pq
// module chunks = 0